import { render, staticRenderFns } from "./SummaryReceipt.vue?vue&type=template&id=1ddc5e37&scoped=true&"
import script from "./SummaryReceipt.vue?vue&type=script&lang=ts&"
export * from "./SummaryReceipt.vue?vue&type=script&lang=ts&"
import style0 from "./SummaryReceipt.vue?vue&type=style&index=0&id=1ddc5e37&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddc5e37",
  null
  
)

export default component.exports